import type { UserRole } from "../types/roles";
export type { UserRole } from "../types/roles";

export type PermissionKey =
  | "shift.assign_any_interviewer"
  | "shift.assign_any_assistant"
  | "shift.remove_any_interviewer"
  | "shift.remove_any_assistant";

export type PermissionMap = Record<PermissionKey, boolean>;

export const EMPTY_PERMISSIONS: PermissionMap = {
  "shift.assign_any_interviewer": false,
  "shift.assign_any_assistant": false,
  "shift.remove_any_interviewer": false,
  "shift.remove_any_assistant": false,
};

export type User = {
  id: string;
  first_name: string;
  last_name: string;
  cod_curso?: string;
  cod_nivel?: string;
  num_ordem?: number;
  role: string;
  roles: UserRole[];
  permissions: PermissionMap;
  email?: string;
  phone?: string;
  preferred_email?: string;
  contact_info_updated_date_utc?: string | null;
};

